var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunction2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48.5,
    stroke: "#4174B8",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2848 33.7133C64.6643 31.093 60.4159 31.0931 57.7958 33.7136L35.3894 56.1226C34.6276 56.8846 34.0921 57.8429 33.8425 58.8912L31.7883 67.5188C31.6752 67.9939 31.8166 68.4936 32.1619 68.839C32.5072 69.1842 33.0069 69.3258 33.482 69.2125L42.1093 67.1584C43.1578 66.9089 44.1165 66.373 44.8786 65.6108L63.6241 46.8633C64.8957 48.1454 64.8925 50.2158 63.6143 51.4939L60.2704 54.8378C59.7213 55.387 59.7213 56.2773 60.2704 56.8264C60.8196 57.3756 61.7099 57.3756 62.2591 56.8264L65.6031 53.4826C67.9795 51.1062 67.9829 47.2549 65.6127 44.8744L67.285 43.2018C69.9049 40.5815 69.9049 36.3335 67.2848 33.7133ZM59.7846 35.7023C61.3064 34.1802 63.7741 34.1801 65.296 35.7021C66.8178 37.2239 66.8179 39.6913 65.2962 41.2132L42.8897 63.6222C42.4957 64.0163 42 64.2933 41.4579 64.4224L35.0536 65.9472L36.5785 59.5426C36.7075 59.0007 36.9844 58.5051 37.3783 58.1112L59.7846 35.7023Z",
    fill: "#4174B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction2);
export default __webpack_public_path__ + "static/media/function-2.3274ebc64c8e24a7baba667ea3972def.svg";
export { ForwardRef as ReactComponent };